import * as React from "react"
import { CSVLink } from "react-csv"
import dayjs from "dayjs"
import { Button, Box } from "@chakra-ui/react"
import { BiDownload } from "react-icons/bi"

import { AlertEntity, AlertType } from "../lib/types/alert"
import { ALERTS } from "../lib/static/alert"
import { coordinatesToPlace } from "../lib/helpers/geocode"

interface Props {
  alerts: AlertEntity[]
}

export const AlertsDownload = (props: Props) => {
  const [data, setData] = React.useState<any>([])
  const headers = [
    { label: "Asset Name", key: "bicycleName" },
    { label: "Asset State", key: "bicycleState" },
    { label: "Battery Level(%)", key: "batteryLevel" },
    { label: "Alert Type", key: "alertType" },
    { label: "Triggered At", key: "triggeredAt" },
    { label: "Address", key: "address" },
    { label: "Latitude", key: "latitude" },
    { label: "Longitude", key: "longitude" },
    { label: "Last Reported GPS Accuracy(metres)", key: "lastReportedGpsAccuracy" },
    { label: "Zone count low", key: "zoneLow" },
    { label: "Zone count high", key: "zoneHigh" },
  ]

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(async () => {
      const alertData = await Promise.all(
        // TODO: Adjust for zone alerts (.extra?.)
        props.alerts.map(async (alert) => ({
          bicycleName: alert.extra?.bicycle_name,
          bicycleState: alert.extra?.bicycle_state,
          batteryLevel: Math.round(alert.extra?.state_of_charge || 0),
          alertType: ALERTS[alert.alert_type as AlertType].label,
          triggeredAt: dayjs(alert.created).format("DD/MM/YYYY HH:mm"),
          address: alert.extra?.location && (await coordinatesToPlace(alert.extra?.location.coordinates)),
          latitude: alert.extra?.location?.coordinates[1],
          longitude: alert.extra?.location?.coordinates[0],
          lastReportedGpsAccuracy: alert.extra?.bicycle_gps_accuracy
            ? Math.round(alert.extra?.bicycle_gps_accuracy * 100) / 100
            : 0,
          // ZONE ALERTS - pending backend
          // zoneLow: alert.zone.name,
          // zoneHigh: alert.zone.name,
        })),
      )
      if (alertData) setData(alertData)
    })()
  }, [props.alerts])

  return props.alerts.length > 0 ? (
    <CSVLink
      tabIndex={-1}
      data={data}
      headers={headers}
      filename={`Alerts Download - ${dayjs().format("YYYY-MM-DD HH-mm-ss")}.csv`}
    >
      <Button
        size="sm"
        variant="outline"
        leftIcon={<Box as={BiDownload} boxSize="18px" />}
        border="1px solid #E2E8F0"
      >
        Download
      </Button>
    </CSVLink>
  ) : (
    <Button isDisabled size="sm" variant="outline" leftIcon={<Box as={BiDownload} boxSize="18px" />}>
      Download
    </Button>
  )
}
